import React from 'react'
import { PageContainerTitleText } from '../../../../../widget/styledComponents/headings.style'
import { GuestListTableContainer } from '../../dues/dues.style'
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style'
import { gql, useQuery,
} from '@apollo/client';
import Cookies from 'js-cookie';
import AddAssetsPlaceholder from '../../../../../widget/add_assets_placeholder';
import { Spinner } from 'evergreen-ui';
import StatusPill from '../widgets/statusPill';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const FETCH_DATA= gql`
query Facility_getDashboardData($facilityId: ID!, $duesTimelimit: Date!) {
  facility_getDashboardData(facilityId: $facilityId, duesTimelimit: $duesTimelimit) {
    complaints {
        _id
        createdAt
        title
        facility
        property {
        _id
        facility
        type
        address
        numberOfRooms
        squareMeter
        createdAt
        resident {
            name
        }
        owner {
            name
        }
        }
        id
        status
        createdBy {
        _id
        name
        email
        address
        }
    }
  }
}
`;

export default function ComplaintsByDate(props) {
const datePicked = props.datePicked
  return (
    <div>
        <GuestListTableContainer 
          style={{
            // height:"520px",
            overflow: "auto",
          }}
        >
                <p>{datePicked}</p>
            
            <PageContainerTitleText>
              Complaint
            </PageContainerTitleText>
            <table className='responsive-table'>
                <thead>
                  <tr>
                      <TableHead>Title</TableHead>
                      <TableHead>Resident Names</TableHead>
                      <TableHead>House No</TableHead>
                      <TableHead>Date</TableHead>
                      <TableHead>Status</TableHead>
                  </tr>
                </thead>
                {/* {facilityId === undefined
                  ? <p></p>
                  :<Complaints/>
                } */}
                <ComplaintsWidgg datePicked={datePicked}/>
                
            </table>
            <center> <AddAssetsPlaceholder/></center>
                
            
        </GuestListTableContainer>
    </div>
  )
}


function ComplaintsWidgg(props) {
const datePicked = props.datePicked
const facilityId = Cookies.get('facilityId');
const history = useHistory()
const { loading,error,data }  = useQuery(FETCH_DATA,{
    variables:{
        facilityId,
        duesTimelimit:datePicked
    }
});
if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const complaint = data.facility_getDashboardData.complaints
  return (
    <tbody>
                  
        {data && 
        complaint.map((comp)=><TableBodyRow
            onClick={()=>history.push(`/complaintById/${comp._id}`)}
        >
            <td>{comp.title}</td>
            <td>
            {comp.createdBy &&  comp.createdBy.name}
            </td>
            <td>{comp.createdBy &&  comp.createdBy.address}</td>
            <td>{comp.createdAt}</td>
            <td><StatusPill status={comp.status}/></td>
            </TableBodyRow>
        )
        }
        
    </tbody>
  )
}
